import { selectProjectById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId")({
	component: Outlet,
	loader: ({ params }) => {
		const project = selectProjectById(params.projectId)(appStore.getState())
		if (!project) throw notFound()
		return project
	},
})
